export default __webpack_public_path__ + "static/media/usha.fdf34f64.jpg";